module.exports = {
  translate: [ 'value', require(53) ]
};